import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import ChangeImpactTable from '../../components/reports/ChangeImpactReports/ChangeImpactTable.jsx';
import SectionHeaderWithSort from '../../components/SectionHeaderWithSort.jsx';
import EmployeeTabMessage from '../../components/employees/EmployeeTabMessage.jsx';
import EmployeeTabPagination from '../../components/employees/EmployeeTabPagination.jsx';
import { EMPLOYEE_PROFILE_SHOW_ALL_OWNERS } from '../../constants/employeeProfile.js';
import {
  retrieveEmployeeChangeImpacts,
  selectEmployeeChangeImpactsState,
} from '../../modules/employees.js';
import { sortBy, sortQueryParams } from '../reports/utils/index.js';

const mapStateToProps = (state, ownProps) => ({
  listState: selectEmployeeChangeImpactsState(ownProps.role)(state),
});

const mapDispatchToProps = {
  retrieveEmployeeChangeImpacts,
};

// One section (Owner or Impacted) of the employee Change Impacts tab,
// with its own sort and pagination.
const EmployeeChangeImpactsSectionContainer = ({
  employeeId,
  role,
  title,
  emptyMessage,
  search,
  listState,
  retrieveEmployeeChangeImpacts,
}) => {
  const [sortType, setSortType] = useState(sortBy[0]);

  const fetchPage = (page) =>
    retrieveEmployeeChangeImpacts(employeeId, {
      role,
      search,
      ...sortQueryParams[sortType],
      page,
    }).catch(() => {});

  useEffect(() => {
    fetchPage(1);
  }, [employeeId, search, sortType]);

  const { items, total, page, totalPages, pending, error } = listState;
  const isCurrentEmployee = listState.employeeId === employeeId;

  const renderContent = () => {
    if (error && !pending) {
      return (
        <EmployeeTabMessage>
          Change impacts could not be loaded.
        </EmployeeTabMessage>
      );
    }
    if (!isCurrentEmployee || (pending && !items.length)) {
      return <EmployeeTabMessage>Loading...</EmployeeTabMessage>;
    }
    if (!items.length) {
      return (
        <EmployeeTabMessage>
          {search ? 'No change impacts match your search.' : emptyMessage}
        </EmployeeTabMessage>
      );
    }
    return (
      <div style={{ opacity: pending ? 0.5 : 1 }}>
        <ChangeImpactTable
          changeImpacts={items}
          showAllOwners={EMPLOYEE_PROFILE_SHOW_ALL_OWNERS}
          linkOwnersToEmployee
        />
        <EmployeeTabPagination
          page={page}
          totalPages={totalPages}
          onPageChange={fetchPage}
        />
      </div>
    );
  };

  return (
    <section>
      <SectionHeaderWithSort
        id={`employee-change-impacts-sort-${role}`}
        title={title}
        total={isCurrentEmployee ? total : 0}
        sortOptions={sortBy}
        onSortChange={setSortType}
      />
      {renderContent()}
    </section>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmployeeChangeImpactsSectionContainer);
